import { IconDownload } from '@hulu-react-style-components/icons';
import { bem } from 'mission-control-common-components';

import type { CustomPacingReport } from '../../../../../../apis/graphql';
import Loader from '../../../../../../common/Loader';
import { fromEmailToName } from '../../../../../../utils/common';
import { formatDate } from '../../../../../../utils/formatting';
import { useDownloadCustomPacingReport } from '../../hooks/useDownloadCustomPacingReport';

const [, element] = bem('custom-pacing-report-list');

type Props = {
  report: CustomPacingReport;
};

const ReportListRow = ({ report }: Props): React.JSX.Element => {
  const { loading, downloadReport } = useDownloadCustomPacingReport(report.id, report.name);

  return (
    <tr>
      <td className={element('col', 'name')}>{report.name}</td>
      <td className={element('col', 'create-date')}>{formatDate(new Date(report.createdAt))}</td>
      <td className={element('col', 'user-created')}>{fromEmailToName(report.createdByUserEmail)}</td>
      <td className={element('col', 'download')}>
        {loading ? <Loader /> : <IconDownload data-testid="download-report" onClick={downloadReport} />}
      </td>
    </tr>
  );
};

export default ReportListRow;
